import useMediaQuery from "../hooks/useMediaQuery"
import { motion } from "framer-motion"
import AnchorLink from "react-anchor-link-smooth-scroll"
import SocialMediaIcons from "../components/SocialMediaIcons"

const Landing = ({setSelectedPage}) => {
    const isAboveMediumScreens = useMediaQuery("(min-width: 1060px)")

  return (
    <section id="home" className="md:flex md:justify-between md:items-center md:h-full gap-16 py-10">

        {/* image section */}
        <div className="md:order-2 flex justify-center basis-3/5 z-10 mt-16 md:mt-10">
            {isAboveMediumScreens ? (
                <div className="">
                    <img 
                        src="../assets/profile-image-5.png" 
                        alt="profile"
                        className="hover:filter hover:saturate-200 transition duration-500 z-10 w-full max-w-[350px] md:max-w-[450px]"
                    />
                </div>
            ) : (
                <img 
                    src="../assets/profile-image-5.png" 
                    alt="profile"
                    className="hover:filter hover:saturate-200 transition duration-500 z-10 w-full max-w-[300px] md:max-w-[400px]"
                />
            )}
            </div>

            {/* main section */}
            <div className="z-30 basis-2/5 mt-12 md:mt-32">
                {/* heading */}
                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{once:true,amount:0.5}}
                    transition={{duration:0.5}}
                    variants={{
                        hidden: {opacity:0,x: -50},
                        visible: {opacity:1,x:0}
                    }}
                >
                    <p className="xs:text-5xl text-3xl font-playfair z-10 text-center md:text-start">
                        Kanchana {""}
                        <span className="xs:relative xs:text-deep-blue xs:font-semibold z-20 before:absolute before:-left-[25px] before:-top-[70px] before:z-[-1]">
                            Walagambahu
                        </span>
                    </p>

                    <p className="mt-10 mb-7 text-sm text-center md:text-start">
                    As a dedicated Front-End Engineer with nearly two years of experience, I specialize in creating
                    responsive, user-friendly web solutions. With a proven track record in increasing user engagement, I'm
                    adept at teamwork and have excellent communication skills. I'm now seeking a new challenge to further
                    contribute to innovative web development.
                    </p>
                </motion.div>

                {/* call to actions */}
                <motion.div
                    className="flex mt-5 justify-center md:justify-start"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{once:true,amount:0.5}}
                    transition={{delay:0.2,duration:0.5}}
                    variants={{
                        hidden: {opacity:0,x: -50},
                        visible: {opacity:1,x:0}
                    }}
                >
                    <AnchorLink 
                        className="text-deep-blue border-solid border-[5px] border-black-500 rounded-sm py-3 px-7 font-semibold hover:bg-[#393E46] hover:text-white transition duration-500"
                        onClick={() => setSelectedPage("contact")}
                        href="#contact"
                    >
                        Contact Me
                    </AnchorLink>
                    <button 
                        className="text-white border-solid border-[5px] border-black-500 rounded-sm py-3 px-7 bg-[#393E46] font-semibold hover:bg-white hover:text-deep-blue transition duration-500"
                        onClick={() => window.open('../assets/Kanchana.w.CV9.pdf')}
                    >
                        Download CV
                    </button>
                    {/* <AnchorLink 
                        className="rounded-r-sm py-0.5 pr-0.5"
                        onClick={() => setSelectedPage("contact")}
                        href="#contact"
                    >
                        <div className="transition duration-500 w-full h-full flex items-center justify-center font-playfair px-10">
                            Lets talk
                        </div>
                    </AnchorLink> */}
                </motion.div>

                {/* social media icons */}
                <motion.div
                    className="flex mt-5 justify-center md:justify-start"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{once:true,amount:0.5}}
                    transition={{delay:0.4,duration:0.5}}
                    variants={{
                        hidden: {opacity:0,x: -50},
                        visible: {opacity:1,x:0}
                    }}    
                >
                    <SocialMediaIcons />

                </motion.div>
            </div>
    </section>
  )
}

export default Landing